import header from "./residence-certificate.png";
import section1 from "./residence-certificate-3.png";
import section2 from "./residence-certificate-4.png";
import section3 from "./handshake.png";
import section4 from "./man-reading-papers.png";
import section5 from "./close-up-hand-take-book.png";
import section6 from "./books-with-hammer.png";
import section7 from "./close-up-laptop-writing.png";
import section8 from "./going-through-checklist.png";
import section9 from "./residence-certificate-2.png";
import section10 from "./frau-schreibt-gesetzestexte-am-laptop.png";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
  section10,
};
